import { render, staticRenderFns } from "./UserIntegralOrder.vue?vue&type=template&id=69fba264&scoped=true&"
import script from "./UserIntegralOrder.vue?vue&type=script&lang=js&"
export * from "./UserIntegralOrder.vue?vue&type=script&lang=js&"
import style0 from "./UserIntegralOrder.vue?vue&type=style&index=0&id=69fba264&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fba264",
  null
  
)

export default component.exports